<svelte:options />

<script lang="ts">
  import { selectFeature } from './sidebar-service';
  import type { A11yLabels, Feature } from './sidebar.types';
  import FeatureComponent from './sidebar-feature.nested.svelte';
  import { EventHandler } from '../../utilities/EventHandler';

  export let data: Feature;
  export let a11yLabels: A11yLabels;

  let eventHandler = new EventHandler();

  function handleBackClick(): void {
    eventHandler.dispatch('back-click', data);
  }

  function handleFeatureClick(feature: Feature): void {
    if (!feature.disabled) {
      selectFeature(feature.code);
    }
  }
</script>

<div class="mc-sidebar-sub-feature" aria-label={data?.label}>
  <button class="mc-sidebar-sub-feature__trigger" on:click={handleBackClick}>
    <span class="mc-sidebar-sub-feature__container">
      <svg width="24px" height="24px" viewBox="0 0 24 24"
        ><path
          d="M9 19a1 1 0 01-.71-.29l-6-6a1 1 0 010-1.42l6-6a1 1 0 111.42 1.42L4.41 12l5.3 5.29a1 1 0 010 1.42A1 1 0 019 19z"
        /><path d="M21 13H3.24a1 1 0 010-2H21a1 1 0 010 2z" /></svg
      >
      <span class="mc-sidebar-sub-feature__trigger__label">{data?.label}</span>
    </span>
  </button>
  {#if data?.items?.length}
    <ul>
      {#each data?.items as feature}
        <li
          class="mc-sidebar-sub-feature__item"
          on:click|stopPropagation={() => handleFeatureClick(feature)}
        >
          <FeatureComponent {feature} {a11yLabels} />
        </li>
      {/each}
    </ul>
  {/if}
</div>

<style lang="scss">
  @import './sidebar-variables';

  .mc-sidebar-sub-feature {
    width: 320px;

    &__trigger {
      background: none;
      border: none;
      cursor: pointer;
      display: flex;
      padding: 0;
      margin: 0;
      font-size: inherit;
      font-family: inherit;
      width: 100%;
      padding: 0px 32px;

      &__label {
        font-size: 16px;
        font-weight: 700;
        margin-left: 8px;
        color: white;
      }

      &:focus-visible {
        box-shadow: none;
        border: none;
        outline: none;

        .mc-sidebar-sub-feature__container {
          box-shadow: none;
          border: none;
          border-radius: 6px;
          outline: 1px solid #0b96cc;
        }
      }
    }

    &__container {
      display: flex;
      align-items: center;
      width: 100%;
      height: 24px;
      padding: 8px 0px;
    }

    ul {
      list-style: none;
      margin: 0;
      padding: 0;
    }
  }
</style>
